import { flow } from 'lodash';
import clsx from 'clsx';
// import Link from 'next/link';
import React, { FunctionComponent, useMemo } from 'react';
import { useCallback } from 'react';
import { useState } from 'react';
import moment from 'moment';
import styles from './ProtocolsPurchaseTab.module.scss';
import {
    ActiveTabsProtocol,
    ProtocolsPurchaseTabProps,
    ReferenceProtocol,
    ReferenceProtocolDoc,
} from './ProtocolsPurchaseTab.type';
import { ArrowDownIcon } from '../../../../Icons';
import { DownloadIcon } from '../../../../Icons';
import { getFileSize } from '../../../../../utils/getFileSize';
import { getTemplateConfig } from '../../../../Purchases/hooks/getTemplateConfig';
import StubAuthRequired from '../../../../Purchases/components/StubAuthRequired';

const ProtocolsPurchaseTab: FunctionComponent<ProtocolsPurchaseTabProps> = ({
    purchase,
    reference,
}) => {
    const [activeTabs, setActiveTabs] = useState<
        ProtocolsPurchaseTabProps['activeTabs']
    >({
        protocols: reference?.protocols?.map(
            (protocol: ReferenceProtocol, pIdx: number) => ({
                isTabActive: true,
            })
        ),
    });
    const isInfoRestricted = useMemo(
        () => getTemplateConfig(purchase).publicAnnounceTabProtocols?.isHidden,
        [purchase]
    );

    const toggleList = useCallback(
        (toggledItemIdx?: number) => {
            const newActiveTabs = {
                protocols: activeTabs?.protocols?.map(
                    (protocol: ActiveTabsProtocol, protocolIdx: number) => ({
                        isTabActive:
                            protocolIdx === toggledItemIdx
                                ? !protocol.isTabActive
                                : protocol.isTabActive,
                    })
                ),
            };
            setActiveTabs(newActiveTabs);
        },
        [activeTabs]
    );

    const listElement = useCallback((title: string | any, definition: any) => {
        if (!title) {
            return null;
        }
        return (
            <>
                <dt key={title}>{title}</dt>
                <dd key={definition}>
                    {definition === null ||
                    definition === undefined ||
                    definition === ''
                        ? '-'
                        : definition}
                </dd>
            </>
        );
    }, []);

    const getFormattedDate = useCallback((date: string): string => {
        return `${moment(date).format('DD.MM.YYYY HH:mm')} МСК`;
    }, []);
    return isInfoRestricted ? (
        <StubAuthRequired />
    ) : (
        <div className={styles.container}>
            <div className={styles.content}>
                {reference?.protocols?.map(
                    (protocol: ReferenceProtocol, protocolIdx: number) => {
                        const isTabActive =
                            activeTabs?.protocols?.[protocolIdx]?.isTabActive;
                        return (
                            <div
                                // eslint-disable-next-line react/no-array-index-key
                                key={`${protocol?.title}-${protocolIdx}`}
                                className={clsx(
                                    styles.item,
                                    isTabActive && styles.active
                                )}
                            >
                                <div
                                    className={styles.lotTitle}
                                    onClick={() => toggleList(protocolIdx)}
                                >
                                    <ArrowDownIcon className={styles.icon} />
                                    {`Протокол ${protocol?.number}`}
                                </div>
                                {isTabActive && (
                                    <div className={styles.itemHidden}>
                                        <dl>
                                            {listElement(
                                                'Номер',
                                                protocol?.number
                                            )}
                                            {listElement(
                                                'Наименование',
                                                protocol?.title
                                            )}
                                            {listElement(
                                                'Дата подписания',
                                                getFormattedDate(
                                                    protocol?.signDate
                                                )
                                            )}
                                        </dl>
                                        {!!protocol?.docs?.length && (
                                            <h3>Документы протокола</h3>
                                        )}
                                        {!!protocol?.docs?.length && (
                                            <ol className={styles.list}>
                                                {protocol?.docs?.map(
                                                    (
                                                        doc: ReferenceProtocolDoc,
                                                        docIdx: number
                                                    ) => {
                                                        return (
                                                            <li
                                                                key={`${doc?.id}-${doc?.fileId}`}
                                                                className={
                                                                    styles.listItem
                                                                }
                                                            >
                                                                <div
                                                                    className={
                                                                        styles.index
                                                                    }
                                                                >
                                                                    {docIdx + 1}
                                                                </div>
                                                                <div
                                                                    className={
                                                                        styles.title
                                                                    }
                                                                >
                                                                    <a
                                                                        href={
                                                                            doc?.downloadUri
                                                                        }
                                                                        title={
                                                                            doc
                                                                                ?.file
                                                                                ?.originalName
                                                                        }
                                                                    >
                                                                        {
                                                                            doc
                                                                                ?.file
                                                                                ?.originalName
                                                                        }
                                                                    </a>
                                                                    <p>
                                                                        <span>
                                                                            Опубликован{' '}
                                                                        </span>
                                                                        {getFormattedDate(
                                                                            protocol?.updateTs
                                                                        )}
                                                                    </p>
                                                                </div>
                                                                <div
                                                                    className={
                                                                        styles.size
                                                                    }
                                                                >
                                                                    {getFileSize(
                                                                        doc
                                                                            ?.file
                                                                            ?.fileSize
                                                                    )}
                                                                </div>
                                                                <a
                                                                    href={
                                                                        doc?.downloadUri
                                                                    }
                                                                >
                                                                    <DownloadIcon />
                                                                </a>
                                                            </li>
                                                        );
                                                    }
                                                )}
                                            </ol>
                                        )}
                                    </div>
                                )}
                            </div>
                        );
                    }
                )}
                {!reference?.protocols?.length && (
                    <div className={styles.empty}>
                        Отсутствуют опубликованные протоколы
                    </div>
                )}
            </div>
        </div>
    );
};

export default flow(() => ProtocolsPurchaseTab)();
